import { useIntl } from "react-intl";
import classNames from "classnames";
import { FAQProps } from "@/utils/formatCategoryPage";
import { StructuredFAQData } from "@/components/common/structuredData/StructuredData";
import { QuestionAndAnswer } from "@/components/common/questionAndAnswer/QuestionAndAnswer";
import styles from "./FAQ.module.scss";

export const FAQ = ({ title, questionsAndAnswers, isFullWidth }: FAQProps) => {
  const intl = useIntl();
  const faqTitle =
    title == null ? intl.formatMessage({ id: "faqTitle" }) : title;

  return (
    <div
      className={classNames(styles.faq, {
        [styles.fullWidth]: isFullWidth,
      })}
    >
      {questionsAndAnswers && questionsAndAnswers.length > 0 && (
        <>
          <StructuredFAQData rawData={questionsAndAnswers} />
          <h2 className={styles.title}>{faqTitle}</h2>
          {questionsAndAnswers.map((qAndA, index) => (
            <QuestionAndAnswer {...qAndA} isOpen={index === 0} key={index} />
          ))}
        </>
      )}
    </div>
  );
};
